// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	/*****************************************************
	OBSERVER TO ADD PARALLAX EFFECT
	*****************************************************/
	const initParallax = () => {
		const elements = document.querySelectorAll(".js-parallax-element");
		if (!elements.length) return;

		const vHeight = window.innerHeight;
		const parallaxItems = Array.from(elements).map((elm) => {
			const bounds = elm.dataset.parallax.split(",").map(Number);
			const distance = bounds[1] - bounds[0];
			const rect = elm.getBoundingClientRect();
			const topElement = rect.top + window.scrollY;
			return {
				elm,
				startValue: bounds[0],
				unitScroll: distance / (vHeight + elm.offsetHeight),
				topElement,
				isIntersecting: false
			};
		});

		window.addEventListener("scroll", () => {
			const scrolled = window.pageYOffset || document.documentElement.scrollTop;
			parallaxItems.forEach((item) => {
				if (item.isIntersecting) {
					const relativeDistance = scrolled + vHeight - item.topElement;
					const transformValue = (item.unitScroll * relativeDistance) + item.startValue;
					item.elm.style.transform = `translate3d(0, ${transformValue}px, 0)`;
				}
			});
		}, { passive: true });

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const item = parallaxItems.find(i => i.elm === entry.target);
				if (item) item.isIntersecting = entry.isIntersecting;
			});
		}, { threshold: 0 });

		elements.forEach((elm) => observer.observe(elm));
	};

	document.addEventListener("DOMContentLoaded", initParallax);
	/********************************************************************************
	END OF OBSERVER TO ADD PARALLAX EFFECT
	***********************************************************************************/

    window.addEventListener("load", function() {
		scrollW();
		if (typeof Body !== 'undefined' && !Body.classList.contains('no-header')) {
			scrollDownAction(50, 'scroll');
		}
		window.addEventListener('scroll', function() {
			requestAnimationFrame(scrollW);
		}, { passive: true });
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	document.addEventListener('DOMContentLoaded', () => {

		/* top-content*/
		const topContent = document.querySelector('.top-content');
		const headerPage = document.getElementById('header');
		if (!topContent) {
			document.body.classList.add('no-header');
			headerPage.classList.add('header-no');
		}

		/* Main Nav Dropdown */
		let primaryNav = document.getElementById('primary-nav');
		if (primaryNav) {
			primaryNav.querySelectorAll('li').forEach(function(li) {
				const submenu = li.querySelector('ul.submenu');
				const link = li.querySelector('a');
				if (submenu) {
					link.classList.add('has-submenu');
					const openMenu = () => {
						submenu.classList.add('open');
						//submenu.style.height = submenu.scrollHeight+12 + "px";
						li.classList.add('is-active');
					};
					const closeMenu = () => {
						submenu.classList.remove('open');
						//submenu.style.height = "0px";
						li.classList.remove('is-active');
					};
					link.addEventListener("click", (e) => {
						e.preventDefault();
						submenu.classList.contains('open') ? closeMenu() : openMenu();
					});
					li.addEventListener("mouseenter", openMenu);
					li.addEventListener("mouseleave", closeMenu);
					li.addEventListener("focusin", openMenu);
					li.addEventListener("focusout", (e) => {
						if (!li.contains(e.relatedTarget)) {
							closeMenu();
						}
					});
					if (link.classList.contains('parent-active')) {
						openMenu();
					}
				}
			});
		}

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});

		/* Lightbox Gallerys */
		const defaultLightbox = new LBX('.js-lbx-default', {
			beforeShow: function () {
				let lightboxSliders = document.querySelectorAll('.images-l-sliders');
				if(lightboxSliders){
					lightboxSliders.forEach(()=>{
						new Swiper('.images-l-sliders', {
							rewind: true,
							effect: "fade",
							fadeEffect: {
								"crossFade": true
							},
							navigation: {
								nextEl: ".sw-but-img-next",
								prevEl: ".sw-but-img-prev",
							},
						});
					});
				}
			},
		});

		//email signup animation 
		let emailSingle = document.getElementById('email-signup');
		if(emailSingle){
			let emailSignup = emailSingle.querySelectorAll('input[type=text], input[type=email], input[type=date]');
			for (const input of emailSignup){
				input.addEventListener('focus', function(){
					this.parentElement.classList.add('moved');
				})
			}
		}

		//CMS forms label animation
		if(document.getElementsByClassName('form-module__field').length > 0){
			let allFields = document.getElementsByClassName('form-module__field');
			for(let j = 0; j < allFields.length; j++){
				if(allFields[j].getElementsByTagName('input').length > 0){
					if(allFields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allFields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
						allFields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
							this.parentElement.classList.add('moved');
						})
					}
				}
				if(allFields[j].getElementsByTagName('select').length > 0){
					allFields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
						this.parentElement.classList.add('moved');
					})
				}
				if(allFields[j].getElementsByTagName('textarea').length > 0){
					allFields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
						this.parentElement.classList.add('moved');
					})
				}
			}
		}

	});

	/* FAQ */
	let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }
	
	/*MOBILE MENU NAV
    ****************************************************************/

	let Html = document.getElementsByTagName('html')[0];
	let MenuBtn = document.getElementById('menu-btn');
	let CloseMenu = document.querySelectorAll('.close-menu');
	let Navigation = document.querySelectorAll('.navigation');
	let NavUl = document.querySelectorAll('.navigation .inner ul li');
	let NavA = document.querySelectorAll('.navigation .inner ul li a');
	let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

	/* Open Navigation */
	if(MenuBtn){
		MenuBtn.addEventListener('click', function(e){
			Html.classList.add('hide-overflow');
			Navigation[0].classList.add('open');
			NavUl.forEach(function(inner) {
				if(inner.classList.contains('item-open')){
					inner.scrollIntoView(false);
				}
			});
		});

		/* Sub-Navigation */
		/* Open active sub-nav on load */
		NavActive.forEach(function(inner) {
			inner.closest('.inner').classList.add('open');
			inner.parentNode.parentNode.parentNode.parentNode.classList.add('li-open');
			inner.closest('.sub-sub-menu').classList.add('menu-open');
		});

		/* Toggle open/close on tap */
		NavA.forEach(function(entry) {
			if(entry.nextElementSibling){
				entry.classList.add('link-parent');
				let clientChildren = entry.nextElementSibling.querySelector('.submenu');
				if(clientChildren != null){
					let clientHeight = clientChildren.clientHeight;
					if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
						entry.nextElementSibling.classList.add('menu-open');
						entry.nextElementSibling.style.height = clientHeight+'px';
						entry.classList.add('hover-open');
						entry.parentNode.classList.add('li-open');
					}
					entry.addEventListener('click', function(e){
						e.preventDefault();
						if(this.nextElementSibling.classList.contains('menu-open')){
							this.nextElementSibling.classList.remove('menu-open');
							this.nextElementSibling.style.height = '0px';
							this.classList.remove('hover-open');
							this.parentNode.classList.remove('li-open');
						} else {
							NavUl.forEach(function(ul) {
								if(ul.querySelector('.sub-sub-menu')){
									if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
										ul.querySelector('.sub-sub-menu').style.height = '0px';
										ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
										ul.querySelector('.link-parent').classList.remove('hover-open');
										ul.querySelector('.link-parent').parentNode.classList.remove('li-open');
									}
								}
							});
							this.nextElementSibling.classList.add('menu-open');
							this.nextElementSibling.style.height = clientHeight+'px';
							this.classList.add('hover-open');
							this.parentNode.classList.add('li-open');
						}
					});
				}
			}
		});
	}

	/* Close Navigation */
	if(CloseMenu[0]){
		CloseMenu[0].addEventListener('click', function(e){
			Html.classList.remove('hide-overflow');
			Navigation[0].classList.remove('open');
		});
	}

	let notCharge = document.querySelectorAll('.not-charge');
	if (notCharge){
		notCharge.forEach(entry => {
			entry.addEventListener('click', function(event){
				event.preventDefault();
			});
		});
	}

	let screenHeight = document.documentElement.clientHeight;
	let homeTopImg = document.getElementById('home');
	if(homeTopImg){
		homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
			if(screen.width < 600){
				entry.style.height = screenHeight-60+'px';
			} else {
				entry.style.height = screenHeight+'px';
			}
		});
		window.addEventListener("resize", function(){
			screenHeight = document.documentElement.clientHeight;
			homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
				if(screen.width < 600){
					entry.style.height = screenHeight-60+'px';
				} else {
					entry.style.height = screenHeight+'px';
				}
			});
		});
	}

	let aBtn = document.querySelectorAll(".btn-primary:not(:where(.attractions-map__expand, .btn-form, .book-now)), .signup-btn, .btn-send");
	if(aBtn){
		setTimeout(() => {
			aBtn.forEach(function(a_btn) {
				let htmlString = a_btn.innerText;
				if(htmlString.toLowerCase().includes('(opens in new window)'.toLowerCase())){
					let result = htmlString.split(/(\([^)]*\))/);
					a_btn.innerHTML = '<span>'+result[0]+'</span><sup class="hidden">'+result[1]+'</sup>';
				} else {
					a_btn.innerHTML = '<span>'+htmlString+'</span>';
				}
			});
		}, 500);
	}

	/* Anchor Animation */
	let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-lbx], a[data-filter], a.accordion-toggle, .link-parent, .skip-to-content))");
	if(aHref){
		aHref.forEach(function(a_href) {
			a_href.addEventListener('click', function(e){
				e.preventDefault();
				let strAnchor = this.hash.slice(1);
				animateto(strAnchor);
			});
		});
	}

})();

function animateto(target){
	var gotoTarget = offset(document.getElementById(target)).top - 110;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300;
	var start = new Date().getTime()

	/* Time Interval */
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {

			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
	/* check scroll down or up for header styles */
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let header = document.getElementById('header');
	let subMenu = document.getElementById('subMenu');
	if(st > 80){
		if (st > lastScrollTop){
			/* downscroll code */
			if(!header.classList.contains('down')){
				header.classList.add('down');
				header.classList.remove('up');
				if(subMenu){
					subMenu.classList.add('down');
					subMenu.classList.remove('up');
				}
			}
		} else {
			/* upscroll code */
			if(!header.classList.contains('up')){
				header.classList.add('up');
				header.classList.remove('down');
				if(subMenu){
					subMenu.classList.add('up');
					subMenu.classList.remove('down');
				}
			}
		}
	} else {
		if(header.classList.contains('up') || header.classList.contains('down')){
			header.classList.remove('up');
			header.classList.remove('down');
			if(subMenu){
				subMenu.classList.remove('up');
				subMenu.classList.remove('down');
			}
		}
	}

	let logoHome = document.getElementById('logo_home');
	if(logoHome){
		if(st > 80){
			if (st > lastScrollTop){
				if(!logoHome.classList.contains('close')){
					logoHome.classList.add('close');
				}
			}
		} else {
			if(logoHome.classList.contains('close')){
				logoHome.classList.remove('close');
			}
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; /* For Mobile or negative scrolling */

}
// Delete the role if the container is empty in the menu
document.addEventListener('DOMContentLoaded', () => {
    const menusItems = document.querySelectorAll('.menus-items');
    menusItems.forEach(item => {
        if (item.children.length === 0 || item.getAttribute('aria-hidden') === 'true') {
            item.removeAttribute('role');
            item.setAttribute('aria-hidden', 'true');
        }
    });
});